import * as types from "./roles.actionTypes";
import { ErrorResponse } from "../../../interfaces/Response";
import { action, createAsyncAction } from "typesafe-actions";
import { createRoleAsyncRequest, createRoleAsyncResponse, getRoleAsyncRequest, getRoleAsyncResponse, selectRoleAsyncRequest, selectRoleAsyncResponse, updateRoleAsyncRequest, updateRoleAsyncResponse } from "./types";

export const resetState = () => action(types.RESET_STATE, {});

export const setError = (value: ErrorResponse) => action(types.SET_ERROR, { value });

export const getRoleAsync = createAsyncAction(
  types.GET_ROLE_REQUEST,
  types.GET_ROLE_SUCCESS,
  types.GET_ROLE_FAILURE
)<getRoleAsyncRequest, getRoleAsyncResponse, ErrorResponse>();

export const updateRoleAsync = createAsyncAction(
  types.UPDATE_ROLE_REQUEST,
  types.UPDATE_ROLE_SUCCESS,
  types.UPDATE_ROLE_FAILURE
)<updateRoleAsyncRequest, updateRoleAsyncResponse, ErrorResponse>();

export const createRoleAsync = createAsyncAction(
  types.CREATE_ROLE_REQUEST,
  types.CREATE_ROLE_SUCCESS,
  types.CREATE_ROLE_FAILURE
)<createRoleAsyncRequest, createRoleAsyncResponse, ErrorResponse>();

export const selectRoleAsync = createAsyncAction(
  types.SELECT_ROLE_REQUEST,
  types.SELECT_ROLE_SUCCESS,
  types.SELECT_ROLE_FAILURE
)<selectRoleAsyncRequest, selectRoleAsyncResponse, ErrorResponse>();